const SHOW_AFTER_PX = 600;

export function initBackToTop(): void {
  const button = document.createElement("button");
  button.type = "button";
  button.className = "back-to-top";
  button.setAttribute("aria-label", "Nach oben scrollen");
  button.textContent = "↑";
  // A native <button> is focusable regardless of CSS - opacity/pointer-events alone
  // (how .is-visible/.has-cookie-banner hide this one) leave it reachable by Tab and,
  // once focused, its own outline is invisible too (opacity: 0 hides the whole box,
  // outline included), which fails WCAG 2.4.7. Kept out of the tab order until it's
  // actually shown; see syncVisibility below.
  button.tabIndex = -1;

  button.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  document.body.append(button);

  const syncVisibility = (): void => {
    const pastThreshold = window.scrollY > SHOW_AFTER_PX;
    button.classList.toggle("is-visible", pastThreshold);
    // The cookie banner forces this button hidden via a CSS override (see
    // .has-cookie-banner .back-to-top) independent of scroll position, so a click-through
    // opt-in/opt-out choice at any point must not leave a stale tabIndex behind.
    const cookieBannerOpen = document.body.classList.contains("has-cookie-banner");
    button.tabIndex = pastThreshold && !cookieBannerOpen ? 0 : -1;
  };

  // A page can load already scrolled past the threshold (a #hash deep link, or the
  // browser restoring scroll position on reload) - without this the button stays
  // hidden until the visitor's next scroll event, even though they're already far down.
  syncVisibility();

  let ticking = false;
  document.addEventListener("scroll", () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      syncVisibility();
      ticking = false;
    });
  });

  // Reacts to the cookie banner opening/closing (toggled independently of scrolling)
  // so tabIndex stays in sync with the CSS override the moment it applies.
  new MutationObserver(syncVisibility).observe(document.body, { attributes: true, attributeFilter: ["class"] });
}
